import React from "react";

import Step1 from "./EquipmentFormSections/step1";
import Step2 from "./EquipmentFormSections/step2";
import Step3 from "./EquipmentFormSections/step3";
import Step4 from "./EquipmentFormSections/step4";
import Step5 from "./EquipmentFormSections/step5";
import Step6 from "./EquipmentFormSections/step6";
import Step7 from "./EquipmentFormSections/step7";
import Step8 from "./EquipmentFormSections/step8";
import Step9 from "./EquipmentFormSections/step9";

import {
  EquipmentFormProvider,
  useEquipmentForm,
} from "../context/EquipmentFormContext";

// ============================================================
// FORM CONTENT
// ============================================================

function EquipmentFormContent() {
  const {
    handleSubmit,
    handleCancel,
    handleFillFakeData,

    creating,
    createSuccess,
    error,

    clearError,
  } = useEquipmentForm();

  return (
    <form
      onSubmit={handleSubmit}
      className="
        space-y-6
        font-sans
        bg-slate-50/30
      "
    >
      {/* =====================================================
          FORM STEPS
      ===================================================== */}

      <Step1 />

      <Step2 />

      <Step3 />

      <Step4 />

      <Step5 />

      <Step6 />

      <Step7 />

      <Step8 />

      <Step9 />

      {/* =====================================================
          API ERROR
      ===================================================== */}

      {error && (
        <div
          className="
            flex
            items-center
            justify-between
            gap-4
            px-4
            py-3
            bg-red-50
            border
            border-red-200
            rounded-lg
          "
        >
          <div>
            <p
              className="
                text-sm
                font-semibold
                text-red-700
              "
            >
              Unable to save equipment
            </p>

            <p
              className="
                text-xs
                text-red-600
                mt-0.5
              "
            >
              {error}
            </p>
          </div>

          <button
            type="button"
            onClick={clearError}
            className="
              text-red-500
              hover:text-red-700
              text-lg
              font-bold
            "
          >
            ×
          </button>
        </div>
      )}

      {/* =====================================================
          SUCCESS
      ===================================================== */}

      {createSuccess && (
        <div
          className="
            px-4
            py-3
            bg-emerald-50
            border
            border-emerald-200
            rounded-lg
          "
        >
          <p
            className="
              text-sm
              font-semibold
              text-emerald-700
            "
          >
            Equipment saved successfully.
          </p>
        </div>
      )}

      {/* =====================================================
          BOTTOM ACTIONS
      ===================================================== */}

      <div
        className="
          flex
          flex-col
          sm:flex-row
          sm:items-center
          sm:justify-between
          gap-3
          pt-4
        "
      >
        {/* ===================================================
            CANCEL
        =================================================== */}

        <button
          type="button"
          onClick={handleCancel}
          disabled={creating}
          className="
            px-6
            py-2.5
            bg-white
            border
            border-gray-300
            hover:bg-gray-50
            text-slate-700
            font-semibold
            text-sm
            rounded-lg
            transition-colors
            disabled:opacity-50
            disabled:cursor-not-allowed
          "
        >
          Cancel
        </button>

        <div
          className="
            flex
            flex-col
            sm:flex-row
            items-stretch
            sm:items-center
            gap-3
          "
        >
          {/* =================================================
              FILL FAKE DATA
          ================================================= */}

          <button
            type="button"
            onClick={handleFillFakeData}
            disabled={creating}
            className="
              px-6
              py-2.5
              bg-violet-50
              border
              border-violet-200
              hover:bg-violet-100
              text-violet-700
              font-semibold
              text-sm
              rounded-lg
              transition-colors
              disabled:opacity-50
              disabled:cursor-not-allowed
            "
          >
            Fill Fake Data
          </button>

          {/* =================================================
              SAVE EQUIPMENT
          ================================================= */}

          <button
            type="submit"
            disabled={creating}
            className="
              min-w-[150px]
              px-8
              py-2.5
              bg-blue-600
              hover:bg-blue-700
              text-white
              font-semibold
              text-sm
              rounded-lg
              shadow-sm
              transition-colors
              disabled:bg-blue-400
              disabled:cursor-not-allowed
              flex
              items-center
              justify-center
              gap-2
            "
          >
            {creating ? (
              <>
                <span
                  className="
                    w-4
                    h-4
                    border-2
                    border-white/40
                    border-t-white
                    rounded-full
                    animate-spin
                  "
                />

                Saving...
              </>
            ) : (
              "Save Equipment"
            )}
          </button>
        </div>
      </div>
    </form>
  );
}

// ============================================================
// MAIN COMPONENT
// ============================================================

export default function EquipmentForm() {
  return (
    <EquipmentFormProvider>
      <EquipmentFormContent />
    </EquipmentFormProvider>
  );
}